import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './SkeletonDetailEventItem.module.scss';
import useWindowDimensions from '@src/Common/Hooks/useWindowDimensions';
interface ISkeletonDetailEventItem {
  containerWidth?: number;
}
const SkeletonDetailEventItem: React.FC<ISkeletonDetailEventItem> = ({
  containerWidth
}) => {
  const { width, height } = useWindowDimensions();
  const fullWidth = width;
  const fullHeight = height > 600 ? height * 0.2 : height * 0.3;
  const widthContainer = containerWidth ?? width;
  const widthGrid = [
    (3 / 5) * widthContainer,
    1 * widthContainer,
    (2 / 5) * widthContainer
  ];

  return (
    <div
      className={styles['popup-content-wrapper']}
      data-testid="detail-event-item"
    >
      <ContentLoader
        uniqueKey="SkeletonDetailEventItem-Default"
        data-testid="SkeletonDetailEventItem-Default"
        speed={2}
        width={widthContainer}
        height={fullHeight}
        viewBox={`0 0 ${fullWidth} 126`}
        backgroundColor="rgba(17, 27, 60, 0.6)"
        foregroundColor="rgba(17, 27, 60, 1)"
      >
        <rect
          x="0"
          y="10"
          rx="0"
          ry="0"
          width={Math.round(widthGrid[0])}
          height="26"
        />
        <rect
          x="0"
          y="43"
          rx="0"
          ry="0"
          width={Math.round(widthGrid[1])}
          height="46"
        />
        <rect
          x="0"
          y="98"
          rx="0"
          ry="0"
          width={Math.round(widthGrid[2])}
          height="14"
        />
      </ContentLoader>
    </div>
  );
};

export default SkeletonDetailEventItem;
